enum GuaranteedIncomeDesignBehaviour
{
    Hidden = 0,
    AdvisoryOnly = 1,
    Enabled = 2
}

export default GuaranteedIncomeDesignBehaviour;
